import { useQuery } from "@tanstack/react-query";
import { getSportWithTranslations } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "./sportsNewQueryKeys";

export const useSportWithTranslations = (id: number | undefined) => {
  return useQuery({
    queryKey: [SportsNewQueryKeys.SportWithTranslations, id],
    queryFn: () => getSportWithTranslations(id!),
    enabled: !!id,
    staleTime: 0,
  });
};
